import Code from './Code';
import Name from './Name';
import Search from './Search';
import RemoteSelect from './RemoteSelect';
import Gender from './Gender';
import Username from './Username';
import Idno from './Idno';
import Tel from './Tel';
import EduSchool from './EduSchool';
import EduDegree from './EduDegree';
import Title from './Title';
import Role from './Role';
import Email from './Email';
import TeacherProperty from './TeacherProperty';
import DualTeacher from './DualTeacher';
import Birthday from './Birthday';
import Modal from './Modal';
import Select from './Select';
import NameCheck from './NameCheck';
import SearchInput from './SearchInput';
import ProfessionalField from './ProfessionalField';
import ResearchDirection from './researchDirection';
import InstructorCode from './instructorCode';

//account
export default {
    SearchInput,
    Code,
    Name,
    Search,
    Gender,
    Username,
    EduSchool,
    EduDegree,
    TeacherProperty,
    Title,
    Role,
    Email,
    DualTeacher,
    Birthday,
    Tel,
    Idno,
    Modal,
    Select,
    NameCheck,
    RemoteSelect,
    ProfessionalField,
    ResearchDirection,
    InstructorCode
}